import App from './App'
import DebugPage from './DebugPage'

function Root() {
    const path = window.location.pathname.replace(/\/+$/, '') || '/'
    return path === '/debug' ? <DebugPage /> : <App />
}

export default Root
